#import '../fragments/document.fragment.gql'

mutation UploadDocumentAttendee($input: UploadDocumentAttendeeInput!) {
  uploadDocumentAttendee(input: $input) {
    id
    type
    signature_status
    deposit_status
    document {
      ...CoreDocumentFields
    }
  }
}

mutation DeleteDocumentAttendee($id: ID!) {
  deleteDocumentAttendee(id: $id) {
    id
  }
}

mutation DeleteContractAttendee($input: DeleteContractAttendeeInput!) {
  deleteContractAttendee(input: $input)
}

mutation DeleteContractsAttendees($input: DeleteContractsAttendeesInput!) {
  deleteContractsAttendees(input: $input) {
    ticket_code
    batch_id
  }
}
